// 📄 pages/Dashboard/searchIndex.ts
// Índice de navegación para el buscador global (ver GlobalSearchModal.tsx)
// — junta en un solo array TODOS los ítems de menú ya definidos en
// menuConfig.tsx/integrationChannels.ts (no se duplica ningún dato, solo se
// normalizan a un shape común con la ruta ya resuelta). No filtra por
// rol/solución activa a propósito: los guards de cada ruta (SolucionGate,
// esCliente, etc.) ya son la autoridad real si el resultado no aplica —
// mismo criterio de "UI refleja, rules/guards deciden" del resto de la app.
import { MenuIcon, funcionalidadesItems, HERRAMIENTAS_ITEMS, PROYECTO_ITEMS, CONFIGURACION_ITEMS, CANALES_COMMERCE_ITEMS } from './menuConfig.tsx';
import { CANALES_INTEGRACION } from '../Proyectos/integrationChannels.ts';

export interface NavSearchResult {
  tipo: 'nav';
  label: string;
  ruta: string;
  icon: MenuIcon;
}

export const buildNavIndex = (projectId: string): NavSearchResult[] => {
  const base = projectId ? `/proyecto/${projectId}` : '';
  const items = [
    ...funcionalidadesItems(true),
    ...HERRAMIENTAS_ITEMS,
    ...PROYECTO_ITEMS,
    ...CONFIGURACION_ITEMS,
    ...CANALES_COMMERCE_ITEMS
  ];

  const nav: NavSearchResult[] = items.map((item) => ({
    tipo: 'nav',
    label: item.label,
    ruta: `${base}/${item.id}`,
    icon: item.icon
  }));

  CANALES_INTEGRACION.forEach((canal) => {
    nav.push({
      tipo: 'nav',
      label: canal.label,
      ruta: `${base}/integracion/${canal.solucion}/${canal.slug}`,
      icon: canal.icon
    });
  });

  return nav;
};
